import {
  IpRestrictionResponse,
  IpRestrictionEntity,
  UpdateIpRestrictionRequest,
  UpsertAllowedIpRequest,
  UpsertAllowedIpFormEntity,
} from 'src/types'

export const IpRestrictionTranslator = {
  toEntity(response: IpRestrictionResponse): IpRestrictionEntity {
    return {
      isIpRestricted: response.isIpRestricted ?? false,
      allowedIps:
        response.allowedIps?.map(ip => ({
          id: ip.id,
          ip: ip.ip,
          description: ip.description,
        })) ?? [],
    }
  },

  toUpdateIpRestrictionRequest: (updatedIsIpRestricted: boolean): UpdateIpRestrictionRequest => {
    return { isIpRestricted: updatedIsIpRestricted }
  },

  toUpsertAllowedIpRequest: (formEntity: UpsertAllowedIpFormEntity): UpsertAllowedIpRequest => {
    return {
      ip: formEntity.ip,
      description: formEntity.description,
    }
  },
} as const
